// Runtime configuration, read once from Vite's import.meta.env. No secrets live
// here — a public SPA holds none (ADR 0015 §14); these are public client config
// (the API base + the staff-realm OIDC public-client coordinates).
export interface AppConfig {
  apiBaseUrl: string;
  oidc: {
    authority: string;
    clientId: string;
    redirectUri: string;
    scope: string;
  };
}

export function loadAppConfig(env: ImportMetaEnv = import.meta.env): AppConfig {
  return {
    apiBaseUrl: (env.VITE_API_BASE_URL ?? "").replace(/\/$/, ""),
    oidc: {
      authority: env.VITE_OIDC_AUTHORITY ?? "",
      clientId: env.VITE_OIDC_CLIENT_ID ?? "",
      redirectUri: env.VITE_OIDC_REDIRECT_URI ?? "",
      scope: env.VITE_OIDC_SCOPE ?? "openid profile email",
    },
  };
}

export const appConfig = loadAppConfig();
